import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'
import { BP } from 'resources/constants'
import { containerCss } from 'app/sofia/components/Structure/Container'
import textureSvg from 'resources/svg/ppl-title-texture.svg'
import checkmarkSvg from 'resources/svg/icons/ppl-checkmark.svg'
import decorationSvg from 'resources/svg/banner-element.svg'

export const Wrapper = styled.div`
  position: relative;

  .image-wrapper {
    position: relative;
    overflow: hidden;

    &::after {
      content: '';
      width: 24vw;
      height: 24vw;
      background: url(${decorationSvg}) no-repeat center / contain;
      position: absolute;
      bottom: -3vw;
      right: -7vw;
      transform: rotate(300deg);
    }

    > img {
      width: 100%;
    }
  }

  .container {
    ${containerCss};
    margin-bottom: 40px;
    ${bp('sm', 'min-width')`
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      z-index: 2;
      height: 100%;
    `}
  }

  .content {
    font-size: clamp(18px, 2vw, 30px);
    line-height: 1.2;
    ${props => bp('sm', 'min-width')`
      color: ${props.theme.palette.general.light};
    `}
  }

  h1 {
    ${props => props.theme.css.heading1};
    font-weight: bold;
    font-size: clamp(20px, 5vw, 80px) !important;
    margin-top: 0;
    ${props => bp('sm')`
      text-align: center;
    `}

    span {
      position: relative;
      display: inline-block;
      z-index: 1;

      &::after {
        content: '';
        display: block;
        background: url(${textureSvg}) no-repeat right / contain;
        height: 30px;
        position: absolute;
        bottom: -12px;
        z-index: -1;
        left: -15px;
        right: -5px;
      }
    }
  }

  h3 {
    font-weight: normal;
    text-align: center;
  }

  .btn {
    @media (min-width: ${BP.md.min}) {
      display: flex !important;
      width: 70vw;
      max-width: 500px;
      margin: auto;
    }
  }

  ul {
    box-sizing: border-box;
    margin: 20px auto 2.5vw;
    list-style: none;
    ${bp('sm', 'min-width')`
      width: 70%;
    `}

    li {
      display: block;
      margin: 5px 0;
      position: relative;
      padding: 0 0 0 2em;

      &::before {
        content: '';
        display: block;
        width: 1em;
        height: 1em;
        background: url(${checkmarkSvg}) no-repeat center / contain;
        position: absolute;
        left: 0;
        top: 0;
        ${props => bp('sm')`
          filter: grayscale(100%) brightness(0);
        `}
      }
    }
  }
`
